var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-card',[_c('d-card-row',[(_vm.property)?_c('v-popup-form',{attrs:{"first-status":true,"property":_vm.property,"close-label":"previous"},on:{"success":_vm.success,"status":_vm.updateNewStatus,"close":_vm.cancelCreatePropertyStatus}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }